import { Star} from 'react-feather';
import util from '@utils/utils';

export const MarkBtn = (props) => {
    const {savedFoldListData,source_id,setMarkData,type,noTxt,color,handleLoginRequired} = props
    
    const handleMarkClick = (e) => {
        e.stopPropagation();
        
        // 检查登录状态，未登录则跳转登录页
        if (!util.requireLogin()) {
            return;
        }
        
        setMarkData(
            {
                data_source:'national_policy',
                source_id:source_id
            }
        );
        document.getElementById('my_mark_modal').showModal()
    };
    
    return (
        <button className={`btn btn-ghost btn-sm btn-secondary ${color ? color : ''}` }
            onClick={handleMarkClick}
        >
            {
                savedFoldListData?.some(i=>i?.save_id_list?.includes(source_id)) ? 
                <>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-warning">
                    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.154.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
                    </svg>
                    {type !== 'row' && !noTxt && <>已收藏</>}
                </> : 
                <>
                    <Star size="15"/>
                    {type !== 'row' && !noTxt && <>收藏</>}
                </>
            }
        </button>
    )
}